import { default as BrowsePage } from './BrowsePage';

export default BrowsePage;
